import {
  IonButtons,
  IonContent,
  IonHeader,
  IonLoading,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToast,
  IonToolbar,
  useIonViewWillEnter,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import "../../components/ExploreContainer.css";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import { requestID, baseUrl, config } from "../../common/utils";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useBusinessContext } from "../../context/business-context";
import { motion } from "framer-motion";
const ManageLedger = () => {
  const { selectedBusinessId, selectedBusinessName } = useBusinessContext();
  const { selectedBusiness} = useBusinessContext()

  const { name } = useParams<{ name: string }>();

  const [ledgetType, setLedgetType] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [ledgerMother, setLedgerMother] = useState([]);
  const [selbranch, setBranch] = useState();

  const [isOpen, setIsOpen] = useState(false);
  const [status, setStatus] = useState({ loading: false, error: false });
  const [errorLogin, setErrorLogin] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [ratingRange, setRatingRange] = useState("0");
  const [message, setMessage] = useState("");
  const [showme, setShowme] = useState(true);
  const [filteredRows, setFilteredRows] = useState([]); // filtered rows state

  const [allLedger, setAllLedger] = useState([]);
  const [checkTeller, setcheckTeller] = useState<Boolean>(false);

  const checkTellerx = () => {
    checkTeller ? setcheckTeller(false) : setcheckTeller(true);

    console.log(checkTeller);
  };

  const callToast = () => {
    setShowToast(true);
    setTimeout(() => setShowToast(false), 5000);
  };

  const getLedgers = () => {
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("business_id", selectedBusiness.business_id);
       formData.append("branch_id", selectedBusiness.branch_id);
       
       setStatus({ loading: true, error: false });
    axios
      .post(baseUrl() + "ledgercreates/getAllLedger_caas_branch", formData, config)
      .then((response) => {
        console.log({ response });
        console.log(response.data.data);

        setAllLedger(response.data.data);
        setStatus({ loading: false, error: false });
      })
      .catch((error) => {
        setStatus({ loading: false, error: false });
        // throw new error("hey ");
      });
  };

  /* const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 15 },
  { field: 'name', headerName: 'LedgerName', width: 220 },
  { field: 'sn', headerName: 'Ledger Code', width: 140},
 // {field: 'ledgerType',headerName: 'ledgerType',width: 90},
  {field: 'ledgerSubHead',headerName: 'ledgerSubHead',width: 299},
  {field: 'ledgerMother',headerName: 'ledgerMother',width: 135},
];
 */
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  function createData(
    name: string,
    calories: number,
    fat: number,
    carbs: number,
    protein: number
  ) {
    return { name, calories, fat, carbs, protein };
  }

  const history = useHistory();
  const gotoCreateLedger = () => {
    //routerLink={`/folder/${filteredModule.url}/${filteredModule.name}`}

    history.push("/folder/createLedger/Create Ledger");
  };
  const rows = allLedger;
  const fetchBranches = async () => {
    try {
      const response = await axios.post(
        baseUrl() + "Businesss/getBranchList",
        { requestID: requestID(), business_id: selectedBusinessId },
        config
      );
      setBranchList(response.data.data || []);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
   // setLoading(false);
  };
  useIonViewWillEnter(() => {
    getLedgers();
    fetchBranches();
    // fetchShopsById();
  });
  useEffect(() => {

    console.log(selbranch)

    if (selbranch === "" || selbranch === undefined) {
      // If no branch is selected, show all rows
      
      setFilteredRows(rows);
    } else {
      // Filter rows based on the selected branch
      setFilteredRows(
        rows.filter((row) => row.branch_id === selbranch)
      );
    }
  }, [selbranch, rows]); // Re-run effect when 'selbranch' or 'allLedger' changes

  return (
    <IonPage className="pushDown">
      {/* <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{selectedBusinessName.toUpperCase()}</IonTitle>
        </IonToolbar>
      </IonHeader> */}

      <IonHeader>
        <Box display="flex" justifyContent="space-between" p={2}>
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Typography variant="h6" sx={{ color: "chocolate", flex: 1 }}>
              {/* <Business className={styles.titleIcon} /> */}
              {selectedBusiness.name.toUpperCase()} - SETUP LEDGER
            </Typography>
          </motion.div>

          <Box sx={{ display: "flex", alignItems: "center" }}>
  

  <Button
    onClick={gotoCreateLedger}
    variant="contained"
    color="success"
    sx={{
      marginLeft: 2,
      minWidth: 200,
      height: 47, // Match the height of the select input
    }}
  >
    Add New
  </Button>

  <Button
    variant="outlined"
    color="secondary"
    onClick={() => history.goBack()}
    sx={{
      marginLeft: 2,
      minWidth: 200,
      height: 47, // Match the height of the select input
    }}
  >
    Go Back
  </Button>
</Box>


        </Box>
      </IonHeader>

      <IonContent fullscreen>
        {/* <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader> */}

        <Box
          sx={{
            paddingTop: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <Divider orientation="horizontal" flexItem />
        </Box>

        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>S/N</StyledTableCell>
              <StyledTableCell>Branch Name</StyledTableCell>
              <StyledTableCell>Name</StyledTableCell>
              <StyledTableCell align="right">Code</StyledTableCell>
              <StyledTableCell align="right">Type&nbsp;</StyledTableCell>
              <StyledTableCell align="right">
                Doc. Sub- Head&nbsp;
              </StyledTableCell>
              <StyledTableCell align="right">
                Doc. Main Head&nbsp;
              </StyledTableCell>
              <StyledTableCell align="right">
                Financial Document&nbsp;
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredRows?.map((row, i) => (
              <StyledTableRow key={i}>
                <StyledTableCell align="left">{row.snx}</StyledTableCell>
                <StyledTableCell align="left">{row.branchName}</StyledTableCell>

                <StyledTableCell align="left">{row.name}</StyledTableCell>
                <StyledTableCell align="left">{row.sn}</StyledTableCell>
                <StyledTableCell align="right">
                  {row.ledgerType}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {row.ledgerSubHead}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {row.ledgerCompHead}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {row.ledgerMother}
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>

        {/*   <div className="colfont" style={{ 
          fontSize: 'smaller', 
          height: '80%', 
          width: '100%' }}>
      <DataGrid
      
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        checkboxSelection
      />
    </div>
 */}

        <IonLoading
          message="Loading..."
          spinner="circles"
          isOpen={status.loading}
        />
        {status.error && (
          <IonToast position="bottom" isOpen={showToast} message={errorLogin} />
        )}
      </IonContent>
    </IonPage>
  );
};

export default ManageLedger;
